var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn--start",on:{"click":function($event){return _vm.$emit('start-game')}}},[_vm._v("start")])}
var staticRenderFns = []

export { render, staticRenderFns }